export { BOT_TYPE_STYLES } from './botColors';
export {
  MAX_INSTAGRAM_BUTTONS_COUNT,
  INSTAGRAM_BUTTON_NAME_MAX_LENGTH,
} from './instagramButtons';
